export default __webpack_public_path__ + "static/media/russian.b57c734c.svg";